import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedLayoutModule } from './layout/layout.module';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { MenubarModule } from 'primeng/menubar';
import { CalendarModule } from 'primeng/calendar';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { TabViewModule } from 'primeng/tabview';
import { SplitButtonModule } from 'primeng/splitbutton';
import { FileUploadModule } from 'primeng/fileupload';
import { ValidationMessagesComponent } from '../../directives/validation-messages/validation-messages.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { InputSwitchModule } from 'primeng/inputswitch';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { DatePipe } from '@angular/common';
import { TreeSelectModule } from 'primeng/treeselect';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { ImageModule } from 'primeng/image';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SplitterModule } from 'primeng/splitter';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { TagModule } from 'primeng/tag';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CardModule } from 'primeng/card';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [
    ValidationMessagesComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedLayoutModule,

    ButtonModule,
    PanelModule,
    TableModule,
    InputTextModule,
    InputTextareaModule,
    InputMaskModule,
    PasswordModule,
    PaginatorModule,
    CheckboxModule,
    InputNumberModule,
    TreeModule,
    TreeTableModule,
    MenubarModule,
    CalendarModule,
    TranslateModule,
    MultiSelectModule,
    DynamicDialogModule,
    FieldsetModule,
    TabViewModule,
    SplitButtonModule,
    FileUploadModule,
    ValidationMessagesComponent,
    RadioButtonModule,
    MaterialFileInputModule,
    MatFormFieldModule,
    MatIconModule,
    InputSwitchModule,
    NgxDocViewerModule,
    TreeSelectModule,
    OrganizationChartModule,
    ImageModule,
    PanelMenuModule,
    SplitterModule,
    DialogModule,
    EditorModule,
    TagModule,
    FloatLabelModule,
    CardModule 
  ],
  providers: [
    DecimalPipe,
    DatePipe
  ]
})
export class SharedModule { }
